import { gql } from '@apollo/client';

export default gql`
  mutation rollbackLoyaltyActivity($activityId: String!, $membershipNumber: String, $useNewLoyaltySystem: Boolean, $actionBy: String) {
    rollbackLoyaltyActivity(
      activityId: $activityId
      membershipNumber: $membershipNumber
      useNewLoyaltySystem: $useNewLoyaltySystem
      actionBy: $actionBy
    ) {
      success
    }
  }
`;
